import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";

//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  addStockFillerInWards,
  assignGraderToFillerInWardsRepeats,
  getAssignCubesFillerToMachinOperators,
  getAssignGraderToFillerStocks,
  getFillerDashboard,
  getFillerInwardStock,
  getFillerPendingStock,
  getFillerRejectStock,
  getFillerStockList,
  updateAssignGraderToFillerInWards,
} from "api";
import { withTranslation } from "react-i18next";
import RaisedButton from "components/Common/RaisedButton";

class FillerDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      dataEntryStockList: [],
      inwardDataEntryStockList: [],
      dashboardInfo: "",
      rejectCubeStockList: [],
      pendingStockList: [],
      rejectStockList: [],
      repeatStockList: [],
    };
  }

  async componentDidMount() {
    const dashboard = await getFillerDashboard();
    if (dashboard && dashboard.data) {
      this.setState({
        dashboardInfo: dashboard.data,
      });
    }
    const pendingStockList = await getAssignGraderToFillerStocks({
      page: this.state.page,
      limit: this.state.sizePerPage,
      fillerStatus: "P",
    });
    if (pendingStockList && pendingStockList.data) {
      this.setState({
        pendingStockList:
          pendingStockList.data.assignGraderToFillerStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : pendingStockList.data.assignGraderToFillerStocks,
      });
    }
    const inwardStockList = await getFillerStockList({
      page: 1,
      limit: 5,
    });
    if (inwardStockList && inwardStockList.data) {
      this.setState({
        inwardDataEntryStockList:
          inwardStockList.data.fillerStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : inwardStockList.data.fillerStocks,
      });
    }
    const rejectList = await getAssignGraderToFillerStocks({
      page: null,
      limit: null,
      fillerStatus: "R",
    });
    if (rejectList && rejectList.data) {
      this.setState({
        rejectStockList:
          rejectList.data.assignGraderToFillerStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : rejectList.data.assignGraderToFillerStocks,
      });
    }
    const rejectStock = await getAssignCubesFillerToMachinOperators({
      page: 1,
      limit: 10,
      machineOperatorStatus: "R",
    });
    if (rejectStock && rejectStock.data) {
      this.setState({
        rejectCubeStockList:
          rejectStock.data.cubeBelts.length == 0
            ? [
                {
                  cubeId: "0",
                  usedCylinder: 0,
                  processId: 0,
                  machineOperatorId: "0",
                  user: {
                    name: "0",
                  },
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  remarks: "0",
                  createdAt: "0",
                },
              ]
            : rejectStock.data.cubeBelts,
      });
    }
    const repeatStock = await assignGraderToFillerInWardsRepeats({
      page: 1,
      limit: 5,
      fillerStatus: "P",
      dataEntryStatus: "A",
    });
    if (repeatStock && repeatStock.data) {
      this.setState({
        repeatStockList:
          repeatStock.data.assignGraderToFillerInWards.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                      partyCode: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                  updatedAt: "",
                  fillerStatus: "P",
                  assignGraderToFillerStock: null,
                },
              ]
            : repeatStock.data.assignGraderToFillerInWards,
      });
    }
  }

  async accept(row) {
    const data = await addStockFillerInWards({
      ...row,
      remarks: row.nextRemarks,
      assignGraderToFillerInWardId: row.id,
    });
    if (data.success == true) {
      const repeatStock = await assignGraderToFillerInWardsRepeats({
        page: 1,
        limit: 5,
        fillerStatus: "P",
        dataEntryStatus: "A",
      });
      this.setState({
        repeatStockList: repeatStock.data.assignGraderToFillerInWards,
      });
    }
  }

  render() {
    this.columns3 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style: { width: "120px" },
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return (
            <div className="d-flex justify-content-start pe-3">
              <div style={{ "margin-right": "5px" }}>{row.jangad.pieces}</div>
              <div className="text-success">({row?.assignGraderToFillerInWards?.length || 0})</div>
            </div>
          );
          // let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(
          //   x => x.ar
          // ).length;
          // ;
          // {
          //   return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
          //     <div className="d-flex justify-content-start pe-3">
          //       <div>{row.jangad.pieces}</div>
          //     </div>
          //   ) : (
          //     <div className="d-flex justify-content-between pe-3">
          //       <div>{row.jangad.pieces}</div>

          //       <div className="text-danger">({tot})</div>
          //     </div>
          //   );
          // }
        },
      },
      {
        dataField: "weight",
        style: { width: "130px" },
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.assignGraderToFillerInWards?.reduce((acc, item) => acc + item.weight, 0).toFixed(2);
          {
            return (
              <div className="d-flex justify-content-start pe-3">
                <div style={{ "margin-right": "5px" }}>{row.jangad.weight}</div>
                <div className="text-success">({tot})</div>
              </div>
            );
          }
          // let tot = row?.dataEntryStock?.stockDataEntryInWards
          //   ?.filter(x => x.ar)
          //   .reduce((acc, item) => acc + item.weight, 0)
          //   .toFixed(2);
          // {
          //   return tot == row.jangad.weight ? (
          //     <div className="d-flex justify-content-start pe-3">
          //       <div>{row.jangad.weight}</div>
          //     </div>
          //   ) : (
          //     <div className="d-flex justify-content-between pe-3">
          //       <div>{row.jangad.weight}</div>

          //       <div className="text-danger">({tot})</div>
          //     </div>
          //   );
          // }
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          return (
            row.jangad.weight != 0 && (
              <>
                <Link
                  to={{
                    pathname: "/filler-edit-verify-accept",
                    query: {
                      isEdit: 1,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded me-2">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </>
            )
          );
        },
      },
    ];
    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style: { width: "120px" },
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(
            x => x.ar
          ).length;
          ;
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style: { width: "130px" },
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards
            ?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.jangad.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          return (
            row.jangad.weight != 0 && (
              <>
                <Link
                  to={{
                    pathname: "/filler-edit-verify-accept",
                    query: {
                      isEdit: 3,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded me-2">
                    <img src="images/dashboard-images/view.svg" />
                  </button>
                </Link>
              </>
            )
          );
        },
      },
    ];

    this.columns5 = [
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.stockDataEntryInWard.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return cell;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return cell;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter(cell, row) {
          return row.process?.name;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(cell).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          return (
            row.jangad.weight != 0 && (
              <RaisedButton
                className={"border-0 p-2 btn-active raised-btn rounded me-2"}
                name="Accept"
                onClick={() => this.accept(row)}
              />
            )
          );
        },
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad?.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad?.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style: { width: "120px" },
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(
            x => x.ar
          ).length;
          ;
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style: { width: "130px" },
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards
            ?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.jangad.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad?.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad?.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
    ];

    this.columns4 = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "cubeId",
        text: `${this.props.t("Belt Id")}`,
        sort: true,
      },
      {
        dataField: "usedCylinder",
        text: `${this.props.t("Used Cylinder")}`,
        sort: true,
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter: (cell, row) => {
          return row.process?.name;
        },
      },
      {
        dataField: "machineOperatorId",
        text: `${this.props.t("Machine Operator")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.user?.name;
        },
      },
      {
        dataField: "remarks",
        text: this.props.t("Filler Notes"),
        sort: true,
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Assigned Date")}`,
        sort: true,
        formatter: cell => {
          return moment(cell).format("DD/MM/YYYY");
        },
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) => {
          if (row.cubeId != "0") {
            return (
              <Link
                to={{
                  pathname: "/filler-edit-filling-process",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" />
                </button>
              </Link>
            );
          }
        },
      },
    ];

    const defaultForCycleSorted = [
      {
        dataField: "cycle",
        order: "asc",
      },
    ];

    document.title = "filler flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Filler Dashboard")} />
            <div className="row">
              <div className="col-xl-4 col-12">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("To Receive / Pending List")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.pending}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Received/My Stock")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.received}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Forward to Machine Opr.")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.forwardToMachineOperator}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-xl-4 col-12 pt-5">
                <h3 className="fw-bold text-black pb-3 text-center text-md-start">
                  {this.props.t("In Testing/QA")}
                </h3>
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("In Testing")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.inTesting}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              {/* <div className="col-xl-4 col-12 pt-5">
                <h3 className="fw-bold text-black pb-3 text-center text-md-start">
                  {this.props.t("Completed (Outward)")}
                </h3>
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("To Receive / Pending List")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.outWard}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Pending List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    // expandRow={expandRow3}
                    data={this.state.pendingStockList}
                    columns={this.columns3}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Inward List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    // expandRow={expandRow1}
                    data={this.state.inwardDataEntryStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Repeat Inward List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.repeatStockList}
                    columns={this.columns5}
                  />
                </div>
              </Card>
            </div>
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {" "}
                  {this.props.t("Rejected List")}{" "}
                </h2>
              </div>
              <Card className="mt-4">
                <BootstrapTable
                  remote
                  keyField="id"
                  headerClasses="fs-5"
                  bordered={false}
                  striped={false}
                  // expandRow={expandRow2}
                  data={this.state.rejectStockList}
                  columns={this.columns2}
                />
              </Card>
            </div>
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {" "}
                  {this.props.t("Belt Rejected By Machine Operator")}{" "}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    keyField="id"
                    bordered={false}
                    striped={false}
                    data={this.state.rejectCubeStockList}
                    columns={this.columns4}
                  />
                </div>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(FillerDashboard);
